import { render, staticRenderFns } from "./doctorList.vue?vue&type=template&id=52d04b8e&scoped=true&"
import script from "./doctorList.vue?vue&type=script&lang=js&"
export * from "./doctorList.vue?vue&type=script&lang=js&"
import style0 from "./doctorList.vue?vue&type=style&index=0&id=52d04b8e&lang=less&scoped=true&"
import style1 from "./doctorList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d04b8e",
  null
  
)

export default component.exports